const titleList = {
    "index":{
        title: "产品详情",
        isShare: "1",
        isBack:"1",
        isFirstPage:"1"
    },
    "notify":{
        title: "健康告知",
        isShare: "0",
        isBack:"1"
    },
    "insure":{
        title: "填写投保信息",
        isShare: "0",
        isBack:"1"
    },
    "payresult":{
        title: "支付结果",
        isShare: "0",
        isBack:"0"
    },
    "protocol":{
        title: " ",
        isShare: "0",
        isBack:"1"
    },
    "visitonline":{
        title: "在线回访",
        isShare: "0",
        isBack:"1"
    },
    "promotionmaterials":{
        title: "推广资料",
        isShare: "0",
        isBack:"1"
    },
    "materialslist":{
        title: "产品资料",
        isShare: "1",
        isBack:"1"
    },
    "guaranteedetail":{
        title: "保障详情",
        isShare: "0",
        isBack:"1"
    },
    "notfound":{
        title: "页面不存在",
        isShare: "0",
        isBack:"1"
    }
};
export {
    titleList
};